<template>
  <section class="layout-container" :id="info.id">
    <!-- 编辑模式 -->
    <template v-if="isEditMode">
      <p class="text" :style="style" v-show="showText" @dblclick="editThis">
        {{ info.value }}
      </p>
      <el-input
        v-show="!showText"
        class="input"
        :style="style"
        ref="inputText"
        v-model="editValue"
        type="textarea"
        autosize
        @blur="recoverText"
        placeholder="双击编辑文本"
      ></el-input>
    </template>

    <!-- 渲染模式 -->
    <template v-else>
      <p :style="style" @click="link()">
        {{ info.value }}
      </p>
    </template>
  </section>
</template>
<script>
export default {
  /******************************************
  ** 文本组件
  * @description 文本组件
  * @author stone
  *****************************************
  info            Object             属性样式数据
  isEditMode      Boolean            是否编辑模式
  *****************************************/
  name: 'textLayout',
  components: {},
  props: {
    info: {
      type: Object
    },
    isEditMode: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      showText: true,
      editValue: this.info.value
    }
  },
  computed: {
    style () {
      const n = this.$util.deepClone(this.info.style)
      n.fontSize += 'px'
      return n
    }
  },
  methods: {
    editThis () {
      this.$emit('disableDrag')
      this.editValue = this.info.value
      this.showText = false
      this.$nextTick(() => {
        this.$refs.inputText.focus()
      })
    },
    link () {
      if (this.info.link) {
        if (this.info.link.indexOf('https://') !== -1) {
          window.location.href = this.info.link
        } else {
          window.location.href = 'https://' + this.info.link
        }
      }
    },
    recoverText () {
      this.$emit('enableDrag')
      this.$store.getters.currentModule.value = this.editValue
      this.showText = true
    }
  },
  mounted () {}
}
</script>
<style lang="scss" scoped>
.layout-container {
  border: 1px solid transparent;
  ::v-deep p,
  ::v-deep .el-textarea__inner {
    font-size: 14px;
    line-height: 33px;
    padding: 0;
    box-sizing: border-box;
    border: 1px solid transparent;
    letter-spacing: 0;
    font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB',
      'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
    color: #3e455c;
    word-break: break-all;
    white-space: pre-line;
  }

  .text {
    &:hover {
      cursor: move;
      border: 1px solid #2354f2;
    }
  }

  ::v-deep .el-textarea__inner {
    border: 1px solid #2354f2;
  }
}
</style>
